module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "vux-timeline-item"
  }, [_c('div', {
    class: ['vux-timeline-item-color', {
      'vux-timeline-item-head': !_vm.isFirst,
      'vux-timeline-item-head-first': _vm.isFirst
    }],
    style: (_vm.headStyle)
  }, [_c('icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFirst && _vm.$parent.isShowIcon),
      expression: "isFirst && $parent.isShowIcon"
    }],
    staticClass: "vux-timeline-item-checked",
    attrs: {
      "type": "success_no_circle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vux-timeline-item-tail",
    style: (_vm.tailStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "vux-timeline-item-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a2d6a85"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/timeline/timeline-item.vue
// module id = 533
// module chunks = 0